export const AssignmentSequence = {
  0: 'None',
  1: 'First',
  2: 'InMiddle',
  3: 'Last',
  4: 'Both',
};
